import { useRef, useState } from 'react';
import classNames from 'classnames/bind';
import { Popover, Overlay } from 'react-bootstrap';
import { faChartLine } from '@fortawesome/pro-regular-svg-icons/faChartLine';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/pro-light-svg-icons/faClose';

import Tooltip from '../../../Tooltip';

import TopInvestorsDetails from '../TopInvestorsDetails';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

export function TopInvestorChartPopover({ investorData }) {
  const [show, setShow] = useState(false);
  const target = useRef(null);

  const handleClick = () => {
    setShow(!show);
  };

  return (
    <div ref={target} className={Styles['popover-wrapper']}>
      <Tooltip
        icon={<FontAwesomeIcon icon={faChartLine} />}
        onClick={handleClick}
        disableOnMobile
        className={cx('popover-icon')}
      >
        View Chart
      </Tooltip>

      <Overlay
        show={show}
        target={target.current}
        placement="left"
        rootClose
        onHide={() => setShow(false)}
      >
        <Popover id="popover-contained" className={Styles.popover}>
          <FontAwesomeIcon
            onClick={handleClick}
            className={Styles['popover-close']}
            icon={faClose}
          />
          <TopInvestorsDetails investorData={investorData} />
        </Popover>
      </Overlay>
    </div>
  );
}

export default TopInvestorChartPopover;
